var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-maps",style:({
    'height': _vm.height,
    'width': _vm.width,
  })},[_c('google-maps-loader',{attrs:{"all-markers-in-view":false}},[[_c('google-maps-data-layer',{attrs:{"json":_vm.region,"downloadable":false}}),_c('google-maps-info-window',[_c('summary-counter')],1)]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }